import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { BillingDetails } from '../types/entities/BillingDetails';
import { address } from './address';

export const billingDetails: SchemaWithClient<BillingDetails> = {
  name: 'Billing Details',
  pluralName: 'Billing Details',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    address: {
      name: 'Address',
      fieldRenderer: SelectField.tableAdapter(address),
      switchboard: true,
      url: address.client.getAllPath,
      tempSchema: address,
    },
    tax_number: {
      name: 'Tax Number',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    vat: {
      name: 'Vat',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    currency: {
      name: 'Currency',
      required: true,
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/billing-details'),
};
